interface PlumeIconProps {
  className?: string
}

export function PlumeIcon({ className }: PlumeIconProps) {
  return (
    <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clipPath="url(#clip0_5_25)">
        <path d="M128 0H0V128H128V0Z" fill="#FF3D00" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30 30.005V56.8446L39.5812 66.4364V39.5968L66.2882 39.6864L56.7118 30.0896L30.005 30L30 30.005ZM78.5888 51.472V75.705L69.0076 66.113V41.8802L78.5888 51.472ZM51.8764 78.2272H76.07L66.4938 68.6304H42.3L51.8764 78.2272ZM92.2048 89.222V65.111L82.6238 55.5192V82.3588L55.9168 82.2694L65.4932 91.866L89.645 91.947L94.7382 97.0484L97.9996 97.5154L97.3784 94.4042L92.2048 89.222Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_25">
          <rect width="128" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
